const CM_INTOOL_COMP_API = '/prvcontent-aggregator/intool-view';
const CM_AGGREGATOR_API = '/content-aggregator/aggregate-pages';
const PREV_CM_AGGREGATOR_API = '/prvcontent-aggregator/aggregate-pages';

export default {
    CM_INTOOL_COMP_API,
    CM_AGGREGATOR_API,
    PREV_CM_AGGREGATOR_API,
};
